const EPSILON = 0.000001

module.exports = {
  EPSILON
}
